import { Component } from '@angular/core';

import { Store } from '@ngrx/store';

import { AgeVerificationActions } from '../../store/age-verification.slice';

@Component({
  selector: 'app-age-verification',
  templateUrl: './age-verification.component.html',
  styleUrls: ['./age-verification.component.scss'],
})
export class AgeVerificationComponent {
  underage = false;

  constructor(private readonly store: Store) {}

  onVerify() {
    this.store.dispatch(AgeVerificationActions.verifyAge());
  }

  onReject() {
    this.underage = true;
  }
}
